var Wallop = require('Wallop');
var scrollMonitor = require("scrollmonitor");
var PubSub = require("underpub-js");
var loadTouchEvents = require('jquery-touch-events');
loadTouchEvents($);

var FullWidthImageSlider = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

FullWidthImageSlider.prototype.init = function(){

  var self = this;
  
  var slider = this.options.$el.find('.Wallop')[0]; // wallop takes a plain JS element, so use [0]
  this.wallop = new Wallop(slider);

  if (this.options.$el.find('.Wallop .Wallop-list .Wallop-item').length > 1)
  {

    // slide timer
    self.slideTimer = window.setInterval(function() {
      self.wallop.next();
    }, 8000);

    // swipe events
    self.options.$el.find('.Wallop').on('swiperight', function() {

      self.wallop.previous();

      // reset slide timer
      clearInterval(self.slideTimer);
      self.slideTimer = window.setInterval(function() {
        self.wallop.next();
      }, 8000);

      
    });

    self.options.$el.find('.Wallop').on('swipeleft', function() {
      
      self.wallop.next();

      // reset slide timer
      clearInterval(self.slideTimer);
      self.slideTimer = window.setInterval(function() {
        self.wallop.next();
      }, 8000);

    });

    // arrow key events
    $(document).keydown(function(e) {

      switch(e.which) {

        // left
        case 37:
          self.wallop.previous();
          // reset slide timer
          clearInterval(self.slideTimer);
          self.slideTimer = window.setInterval(function() {
            self.wallop.next();
          }, 8000);
          break;

        // right
        case 39:
          self.wallop.next();
          // reset slide timer
          clearInterval(self.slideTimer);
          self.slideTimer = window.setInterval(function() {
            self.wallop.next();
          }, 8000);
          break;

      }

    });

  }

  // when slider has navigation
  /*
  this.elementWatcher = scrollMonitor.create( this.options.$el.find('.navigation-scroll-watcher')[0] );

  this.elementWatcher.stateChange(function() {

    // only run this if the element is currently in the body
    // this check prevents scrollmonitor from still running on pjax loaded
    // pages that don't have a full width image slider on them
    if ((document.body.contains(self.options.$el[0])) && (self.options.$el.hasClass('has-nav')))
    {

      if (self.elementWatcher.isInViewport)
      {
        PubSub.publish("disableHeaderNavigation", {});
      }
      else
      {
        PubSub.publish("enableHeaderNavigation", {});
      }

    }

  });
  */

  /*
  if (this.elementWatcher.isInViewport)
  {
    if (document.body.contains(self.options.$el[0]))
    {
      PubSub.publish("disableHeaderNavigationInstant", {});
    }
  }
  */

  // mobile nav trigger
  this.options.$el.find('.mobile-nav-trigger').on('click', function() {

    if ($(this).hasClass('is-active'))
    {
      PubSub.publish("hideMobileNavOverlay", {});
    }
    else
    {
      PubSub.publish("showMobileNavOverlay", {});
    }

    $(this).toggleClass('is-active');

  });

  // allow other hamburgers to activate/deactivate this one
  PubSub.subscribe("deactivateHamburgers", function(){
    self.deactivateHamburger();
  });

  PubSub.subscribe("activateHamburgers", function(){
    self.activateHamburger();
  });

};

FullWidthImageSlider.prototype.activateHamburger = function(){
  this.options.$el.find('.mobile-nav-trigger').addClass('is-active');
};

FullWidthImageSlider.prototype.deactivateHamburger = function(){
  this.options.$el.find('.mobile-nav-trigger').removeClass('is-active');
};

module.exports = FullWidthImageSlider;
